import CardItemJobPositionsAndRole from './CardItemJobPositionsAndRole'

export default CardItemJobPositionsAndRole
